"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Risk API
 * Risk Service API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VulnerabilityToJSON = exports.VulnerabilityFromJSONTyped = exports.VulnerabilityFromJSON = exports.instanceOfVulnerability = void 0;
var runtime_1 = require("../runtime");
var RiskCVE_1 = require("./RiskCVE");
var Severity_1 = require("./Severity");
var Source_1 = require("./Source");
/**
 * Check if a given object implements the Vulnerability interface.
 */
function instanceOfVulnerability(value) {
    var isInstance = true;
    isInstance = isInstance && "issueID" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "assetCount" in value;
    isInstance = isInstance && "riskCount" in value;
    isInstance = isInstance && "riskCountUnresolved" in value;
    isInstance = isInstance && "riskCountResolved" in value;
    isInstance = isInstance && "riskPercentResolved" in value;
    isInstance = isInstance && "score" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "firstDetectedTime" in value;
    isInstance = isInstance && "lastDetectedTime" in value;
    isInstance = isInstance && "issuePublishTime" in value;
    isInstance = isInstance && "issueUpdateTime" in value;
    isInstance = isInstance && "cisaKnownExploit" in value;
    return isInstance;
}
exports.instanceOfVulnerability = instanceOfVulnerability;
function VulnerabilityFromJSON(json) {
    return VulnerabilityFromJSONTyped(json, false);
}
exports.VulnerabilityFromJSON = VulnerabilityFromJSON;
function VulnerabilityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'issueID': json['issueID'],
        'name': json['name'],
        'description': json['description'],
        'assetCount': json['assetCount'],
        'riskCount': json['riskCount'],
        'riskCountUnresolved': json['riskCountUnresolved'],
        'riskCountResolved': json['riskCountResolved'],
        'riskPercentResolved': json['riskPercentResolved'],
        'score': json['score'],
        'severity': (0, Severity_1.SeverityFromJSON)(json['severity']),
        'cve': !(0, runtime_1.exists)(json, 'cve') ? undefined : (0, RiskCVE_1.RiskCVEFromJSON)(json['cve']),
        'recommendations': !(0, runtime_1.exists)(json, 'recommendations') ? undefined : json['recommendations'],
        'references': !(0, runtime_1.exists)(json, 'references') ? undefined : json['references'],
        'firstDetectedTime': (new Date(json['firstDetectedTime'])),
        'lastDetectedTime': (new Date(json['lastDetectedTime'])),
        'issuePublishTime': (new Date(json['issuePublishTime'])),
        'issueUpdateTime': (new Date(json['issueUpdateTime'])),
        'cisaKnownExploit': json['cisaKnownExploit'],
        'sources': !(0, runtime_1.exists)(json, 'sources') ? undefined : (json['sources'].map(Source_1.SourceFromJSON)),
    };
}
exports.VulnerabilityFromJSONTyped = VulnerabilityFromJSONTyped;
function VulnerabilityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'issueID': value.issueID,
        'name': value.name,
        'description': value.description,
        'assetCount': value.assetCount,
        'riskCount': value.riskCount,
        'riskCountUnresolved': value.riskCountUnresolved,
        'riskCountResolved': value.riskCountResolved,
        'riskPercentResolved': value.riskPercentResolved,
        'score': value.score,
        'severity': (0, Severity_1.SeverityToJSON)(value.severity),
        'cve': (0, RiskCVE_1.RiskCVEToJSON)(value.cve),
        'recommendations': value.recommendations,
        'references': value.references,
        'firstDetectedTime': (value.firstDetectedTime.toISOString()),
        'lastDetectedTime': (value.lastDetectedTime.toISOString()),
        'issuePublishTime': (value.issuePublishTime.toISOString()),
        'issueUpdateTime': (value.issueUpdateTime.toISOString()),
        'cisaKnownExploit': value.cisaKnownExploit,
        'sources': value.sources === undefined ? undefined : (value.sources.map(Source_1.SourceToJSON)),
    };
}
exports.VulnerabilityToJSON = VulnerabilityToJSON;
